import { TextToImageProvider } from 'redux/middleware/api/image-search-service';
import { TextToImageEngine } from './types';

export const TEXT_TO_IMAGE_ENGINE_TO_PROVIDER: Record<
  TextToImageEngine,
  TextToImageProvider
> = {
  [TextToImageEngine.OPEN_AI]: 'openai',
  [TextToImageEngine.GEMINI]: 'gemini',
};

export const TEXT_TO_IMAGE_ENGINE_DISPLAY_NAME: Record<
  TextToImageEngine,
  string
> = {
  [TextToImageEngine.OPEN_AI]: 'OpenAI',
  [TextToImageEngine.GEMINI]: 'Gemini',
};
